module.exports = __webpack_public_path__ + "68c27f48909b8fcbae715cec73f0117f.svg";